<template>
    <thead>
        <tr v-for="crumb in breadcrumbs"
            :key="crumb.name"
            @click="$emit('crumb-click', crumb)"
            class="table--hover__row__last_unclickable"
        >
            <td>{{localizeName(crumb.name)}}</td>
            <td v-for="entry in crumb.data">
                {{entry.value}}
            </td>
        </tr>
    </thead>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';

    @Component
    export default class GeoTableBreadCrumb extends Vue {
        @Prop({type: Array, default: () => ([])})
        breadcrumbs;
        @Prop({type: Array, default: () => (['lead'])})
        columns;

        localizeName(name) {
            // If a translation exists for the rowname as a country, return it otherwise return raw name
            const path = 'countries.' + name;
            if (this.$te(path)) {
                return this.$t(path);
            } else {
                return name;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/geotable/GeoTableBreadCrumb.vue